export default "__VITE_ASSET__DCQJf6ff__"